import React from 'react';

const ChatIcon = ({ className = "w-6 h-6", color = "#2861BB" }) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M24 5.34745V18.7372H20.5714V23L15.1339 18.7372H7.15179L9.29464 17.0635H15.7232L18.8571 19.4956V17.0635H22.2857V7.02117H18.8571V5.34745H24ZM17.1429 2V15.3898H8.86607L4.82143 18.5542L3.42857 19.6526V15.3898H0V2H17.1429ZM15.4286 3.67373H1.71429V13.7161H5.14286V16.1482L8.03571 13.8991L8.27679 13.7161H15.4286V3.67373Z" 
        fill={color}
      />
      <mask 
        id="mask0_6199_126263" 
        style={{maskType: "luminance"}} 
        maskUnits="userSpaceOnUse" 
        x="0" 
        y="2" 
        width="24" 
        height="21"
      >
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M24 5.34745V18.7372H20.5714V23L15.1339 18.7372H7.15179L9.29464 17.0635H15.7232L18.8571 19.4956V17.0635H22.2857V7.02117H18.8571V5.34745H24ZM17.1429 2V15.3898H8.86607L4.82143 18.5542L3.42857 19.6526V15.3898H0V2H17.1429ZM15.4286 3.67373H1.71429V13.7161H5.14286V16.1482L8.03571 13.8991L8.27679 13.7161H15.4286V3.67373Z" 
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_6199_126263)">
      </g>
    </svg>
  );
};

export default ChatIcon;